import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCheckCircle, faTimesCircle, faEdit, faTrash, faUsers
} from '@fortawesome/free-solid-svg-icons';
import styles from '../../pages/Dashboard.module.css';

const TimesheetListView = ({
    filteredEntries,
    selectedEntries,
    setSelectedEntries,
    toggleSelectAll,
    toggleSelectEntry,
    handleBulkApprove,
    handleBulkReject,
    handleSingleApprove,
    handleSingleReject,
    handleEdit,
    handleDelete,
    isWeekend,
    getHoursColor,
    getStatusBadge,
    searchTerm,
    dateFilter,
    employeeFilter,
    chantierFilter
}) => {
    return (
        <>
            {/* Bulk Actions Bar */}
            {selectedEntries.length > 0 && (
                <div style={{
                    background: 'var(--color-primary)',
                    color: 'white',
                    padding: '1rem 1.5rem',
                    borderRadius: 'var(--border-radius-lg)',
                    marginBottom: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <span style={{ fontWeight: 'bold' }}>
                        {selectedEntries.length} entrée(s) sélectionnée(s)
                    </span>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button
                            onClick={handleBulkApprove}
                            style={{
                                background: '#10b981',
                                color: 'white',
                                border: 'none',
                                padding: '8px 16px',
                                borderRadius: '6px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <FontAwesomeIcon icon={faCheckCircle} />
                            Valider
                        </button>
                        <button
                            onClick={handleBulkReject}
                            style={{
                                background: '#ef4444',
                                color: 'white',
                                border: 'none',
                                padding: '8px 16px',
                                borderRadius: '6px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <FontAwesomeIcon icon={faTimesCircle} />
                            Rejeter
                        </button>
                        <button
                            onClick={() => setSelectedEntries([])}
                            style={{
                                background: 'transparent',
                                color: 'white',
                                border: '1px solid white',
                                padding: '8px 16px',
                                borderRadius: '6px',
                                fontWeight: '600',
                                cursor: 'pointer'
                            }}
                        >
                            Annuler
                        </button>
                    </div>
                </div>
            )}

            <div className={styles.tableContainer}>
                <table className={styles.dataTable}>
                    <thead>
                        <tr>
                            <th style={{ width: '40px' }}>
                                <input
                                    type="checkbox"
                                    checked={selectedEntries.length === filteredEntries.length && filteredEntries.length > 0}
                                    onChange={toggleSelectAll}
                                    style={{ cursor: 'pointer' }}
                                />
                            </th>
                            <th>Date</th>
                            <th>Employé</th>
                            <th>Chantier</th>
                            <th>Heures</th>
                            <th>Description</th>
                            <th>Statut</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredEntries.map((entry) => {
                            const statusBadge = getStatusBadge(entry.status);
                            const entryIsWeekend = isWeekend(entry.date);
                            return (
                                <tr key={entry.id} style={{
                                    backgroundColor: entryIsWeekend ? 'rgba(59, 130, 246, 0.05)' : 'transparent'
                                }}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selectedEntries.includes(entry.id)}
                                            onChange={() => toggleSelectEntry(entry.id)}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            {new Date(entry.date).toLocaleDateString('fr-FR')}
                                            {entryIsWeekend && (
                                                <span style={{
                                                    fontSize: '0.7rem',
                                                    padding: '2px 6px',
                                                    background: '#3b82f6',
                                                    color: 'white',
                                                    borderRadius: '4px',
                                                    fontWeight: 'bold'
                                                }}>
                                                    W-E
                                                </span>
                                            )}
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <FontAwesomeIcon icon={faUsers} style={{ color: 'var(--color-text-light)' }} />
                                            <span>{entry.workerName || entry.expand?.worker?.name || entry.expand?.worker?.username || 'Inconnu'}</span>
                                        </div>
                                    </td>
                                    <td style={{ fontWeight: 'bold' }}>
                                        {entry.expand?.chantier?.name || '-'}
                                    </td>
                                    <td>
                                        <span style={{
                                            fontWeight: 'bold',
                                            fontSize: '1rem',
                                            color: getHoursColor(entry.hours),
                                            padding: '4px 8px',
                                            background: getHoursColor(entry.hours) + '15',
                                            borderRadius: '6px'
                                        }}>
                                            {entry.hours}h
                                        </span>
                                    </td>
                                    <td style={{
                                        color: 'var(--color-text-light)',
                                        fontStyle: 'italic',
                                        maxWidth: '250px',
                                        fontSize: '0.9rem'
                                    }}>
                                        {entry.description || '-'}
                                    </td>
                                    <td>
                                        <span style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            padding: '4px 10px',
                                            background: statusBadge.bg,
                                            color: statusBadge.color,
                                            borderRadius: '6px',
                                            fontSize: '0.85rem',
                                            fontWeight: '600'
                                        }}>
                                            <FontAwesomeIcon icon={statusBadge.icon} />
                                            {statusBadge.label}
                                        </span>
                                    </td>
                                    <td className={styles.actions}>
                                        {(entry.status === 'pending' || !entry.status || entry.status === 'pending_manager' || entry.status === 'pending_rh') && (
                                            <>
                                                <button
                                                    className={styles.iconBtn}
                                                    onClick={() => handleSingleApprove(entry.id)}
                                                    title="Valider"
                                                    style={{ background: '#10b981', color: 'white' }}
                                                >
                                                    <FontAwesomeIcon icon={faCheckCircle} />
                                                </button>
                                                <button
                                                    className={styles.iconBtn}
                                                    onClick={() => handleSingleReject(entry.id)}
                                                    title="Rejeter"
                                                    style={{ background: '#ef4444', color: 'white' }}
                                                >
                                                    <FontAwesomeIcon icon={faTimesCircle} />
                                                </button>
                                            </>
                                        )}
                                        <button className={styles.edit} onClick={() => handleEdit(entry)} title="Modifier">
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button className={styles.delete} onClick={() => handleDelete(entry.id)} title="Supprimer">
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                        {filteredEntries.length === 0 && (
                            <tr>
                                <td colSpan="8" style={{ textAlign: 'center', padding: '2rem' }}>
                                    {searchTerm || dateFilter !== 'ALL' || employeeFilter !== 'ALL' || chantierFilter !== 'ALL'
                                        ? 'Aucune entrée ne correspond à vos critères.'
                                        : 'Aucune entrée d\'heure trouvée.'
                                    }
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default TimesheetListView;
